import React, { type FunctionComponent } from 'react'
import { ListItem } from '../../../../common/styled'
import { Status } from '../../../../common/styled/Status'
import { ArrowRightIcon } from '../../../../icons'
import { useNavigate } from 'react-router'
import { campaignRunningStateMap } from '../../common/charityCampaignMap'
import { schemeMap } from '../../common/charity'

type Props = {
  charity: CharitySummaryType
}

export const CharityListItem: FunctionComponent<Props> = ({ charity }) => {
  const navigate = useNavigate()

  const { id, displayName, organizationName, campaignRunState, status, appContext } = charity

  return (
    <ListItem
      onClick={() => navigate(`/charities/${id}`)}
      ariaLabel={`Show charity ${displayName}`}
      label={
        <div className="flex">
          <div className="flex-1 flex flex-col items-start space-y-sm">
            <div className="tag inline-block">{schemeMap[appContext]}</div>
            <h2 className="font-bold pl-sm">{displayName}</h2>
            <div className="text-sm pl-sm">{organizationName}</div>
          </div>

          <div className="flex justify-end items-center space-x-md">
            <div className="text-right h-full flex flex-col items-end space-y-sm">
              <div className="inline-block font-bold text-sm tag">Charity</div>
              {status !== 'NEW' ? (
                <div className="font-bold">{campaignRunningStateMap[campaignRunState]}</div>
              ) : (
                <Status status={status} />
              )}
            </div>

            <ArrowRightIcon width="1rem" height="1rem" />
          </div>
        </div>
      }
    />
  )
}
